<template>
	<v-card flat class="ma-0">
		<v-form ref="form" @submit.prevent>
			<h6 class="text-body-1 font-weight-bold mt-2">絞り込み</h6>
			<v-row no-gutters justify="center">
				<v-col cols="12" lg="4" md="6" class="pl-md-1">
					<v-select
						label="アラートの種類"
						:items="alertTypes"
						item-value="id"
						item-text="name"
						v-model="q.todo"
						class="mt-4"
						outlined
						dense
					/>
				</v-col>
				<v-col cols="12" lg="4" md="6" class="px-md-1">
					<v-select
						label="担当者"
						:items="users"
						item-value="id"
						item-text="full_name"
						v-model="q.todo"
						class="mt-4"
						outlined
						dense
					/>
				</v-col>
				<v-col cols="12" sm="6" lg="4" class="mt-4 px-1">
					<v-row no-gutters>
						<v-col cols="6" class="pr-1">
							<v-btn width="100%" @click="search" color="secondary">
								<v-icon class="mr-2">mdi-magnify</v-icon>
								検索</v-btn
							>
						</v-col>
						<v-col cols="6" class="pl-1">
							<v-btn width="100%" @click="resetForm" outlined color="secondary">
								<v-icon class="mr-2">mdi-autorenew</v-icon>
								クリア</v-btn
							>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-form>
	</v-card>
</template>

<script>
import IncrementalSearchForm from "../../shared/IncrementalSearchForm.vue"

export default {
	props: {
		text: {
			type: Boolean,
			default: false,
		},
		query: {
			type: Object,
			required: true,
		},
    users:{
      type: Array,
      required: true,
    }
	},
	components: {
		IncrementalSearchForm,
	},
	data() {
		return {
			q: {
				ordered_product_product_number_cont: null,
				backup_flag_eq: false,
			},
			alertTypes: [
				{ name: "承認予定日超過", id: 1 },
				{ name: "出荷日間近納入先未入力", id: 2 },
				{ name: "書類不揃い", id: 3 },
				{ name: "納期間近未受注", id: 4 },
			],
		}
	},
	mounted() {
		this.q = this.query
	},
	methods: {
		search() {
			this.$emit("search", this.q)
		},
		resetForm() {
			this.$refs.form.reset()
		},
	},
	watch: {
		query: {
			handler(val) {
				this.q = val
			},
			deep: true,
		},
	},
}
</script>